import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import '../utils/assertion.esm.js';
import '../utils/ssr.esm.js';
import '../utils/number.esm.js';
import '../utils/array.esm.js';
import '../utils/breakpoint.esm.js';
import '../utils/context.esm.js';
import '../utils/dom.esm.js';
import '../utils/tabbable.esm.js';
import '../utils/dom-query.esm.js';
import '../utils/logger.esm.js';
import '../utils/focus.esm.js';
import { callAllHandlers } from '../utils/function.esm.js';
import '../utils/keydown.esm.js';
import '../utils/lazy.esm.js';
import '../utils/object.esm.js';
import '../utils/react-helpers.esm.js';
import '../utils/style-props.esm.js';
import '../utils/tailwind.esm.js';
import { useControllableProp } from './use-controllable.esm.js';
import { useId } from './use-id.esm.js';
import { usePrevious } from './use-previous.esm.js';

function useDisclosure(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      onCloseProp = _props.onClose,
      onOpenProp = _props.onOpen,
      isOpenProp = _props.open,
      idProp = _props.id;

  var _React$useState = React__default.useState(props.defaultOpen || false),
      isOpenState = _React$useState[0],
      setIsOpen = _React$useState[1];

  var _useControllableProp = useControllableProp(isOpenProp, isOpenState),
      isControlled = _useControllableProp[0],
      isOpen = _useControllableProp[1];

  var prevIsOpen = usePrevious(isOpen);
  var id = useId(idProp, 'disclosure');
  var onClose = React__default.useCallback(function () {
    if (!isControlled) {
      setIsOpen(false);
    }

    onCloseProp == null ? void 0 : onCloseProp();
  }, [isControlled, onCloseProp]);
  var onOpen = React__default.useCallback(function () {
    if (!isControlled) {
      setIsOpen(true);
    }

    onOpenProp == null ? void 0 : onOpenProp();
  }, [isControlled, onOpenProp]);
  var onToggle = React__default.useCallback(function () {
    var action = isOpen ? onClose : onOpen;
    action();
  }, [isOpen, onOpen, onClose]);
  return {
    open: !!isOpen,
    prevIsOpen: !!prevIsOpen,
    onOpen: onOpen,
    onClose: onClose,
    onToggle: onToggle,
    isControlled: isControlled,
    getButtonProps: function getButtonProps(buttonProps) {
      if (buttonProps === void 0) {
        buttonProps = {};
      }

      return _extends({}, buttonProps, {
        'aria-expanded': 'true',
        'aria-controls': id,
        onClick: callAllHandlers(buttonProps.onClick, onToggle)
      });
    },
    getDisclosureProps: function getDisclosureProps(disclosureProps) {
      if (disclosureProps === void 0) {
        disclosureProps = {};
      }

      return _extends({}, disclosureProps, {
        hidden: !isOpen,
        id: id
      });
    }
  };
}

export { useDisclosure };
//# sourceMappingURL=use-disclosure.esm.js.map
